var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAffiliateAddProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 12.75V7.33333C21 7.09622 20.8604 6.88135 20.6437 6.78505L12.2437 3.05171C12.0885 2.98276 11.9115 2.98276 11.7563 3.05171L3.35632 6.78505C3.13964 6.88135 3 7.09622 3 7.33333V17.5535C3 17.7906 3.13964 18.0055 3.35632 18.1018L11.7563 21.8351C11.9115 21.904 12.0885 21.904 12.2437 21.8351L15.5963 20.3451",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 6.75L12 10.95M12 10.95L3 6.75M12 10.95V21.75",
    stroke: "black",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4999 8.88991V12.5M8.05566 4.74701L15.4478 8.03239L16.5487 8.52168",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 15V19.5M17.25 17.25H21.75",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAffiliateAddProduct);
export default __webpack_public_path__ + "static/media/affiliate-add-product.5d150f8ed6485f35eac6d3a46c6fe7ec.svg";
export { ForwardRef as ReactComponent };